<template>

<!--    Phone verification component - modal-->
<!--    phone confirmation component when is NOT modal-->
<!--    this component is gonna be shown if user has not confirmed phone number yet and selected product requires phone verification.-->
    <div v-if="this.showPhoneConfirmation && this.phoneConfirmationIsModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered my-0" role="document">
            <div class="modal-content">
                <div class="modal-body p-4">
                    <PhoneConfirmation
                        @phoneConfirmed="this.handlePhoneConfirmation"
                        @phoneConfirmationFailed="this.handlePhoneConfirmationFailed"
                        :phoneNumberProp="this.$parent.maskedPhoneNumber"
                        :uid="this.$parent.uid"
                        :isModal="true" ref="phoneConfirmationComponent"
                        :canConfirmPhone="this.canConfirmPhone"
                        :maxFailedAttempts="this.settings.phoneConfirmationMaxFailedAttempts"
                        :failedAttempts="this.phoneConfirmationFailedAttempts"
                    />
                </div>
                <div class="modal-footer px-4 d-flex justify-content-between">
                    <a href="/loan" target="_blank" class="btn btn-sm btn-outline-primary w-auto m-0">New Application</a>
                    <div class="d-flex m-0">
                        <button type="button" class="btn btn-secondary w-auto ms-2" :class="{'btn-sm' : this.settings.isMobile}" @click="this.settings.selectedProduct = null">Close</button>
                        <button v-if="this.canConfirmPhone" type="button" class="btn btn-success w-auto ms-2" :class="{'btn-sm' : this.settings.isMobile}" @click="this.$refs.phoneConfirmationComponent.doConfirmPhoneRequest()">Verify</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Container -->
    <div class="container-fluid p-0" style="min-height: 100%;">

        <!-- Navitation Bar -->
        <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm p-0">
            <div class="container">
                <a class="navbar-brand p-0 mx-auto me-auto" href="https://loanscanada.ca/" title="CompareHub by LoansCanada">
                    <img alt="Loans Canada Logo" class="my-2 mx-auto" src="https://app.loanscanada.ca/assets/images/compare-hub-logo.png" style="height:3.5rem; width:auto;">
                </a>
                <template v-if="this.settings.isPhoneConfirmed">
                    <button class="btn btn-toggle-menu btn-outline-primary position-absolute" @click="this.toggleSidebar()" style="top: 50%; right: 15px; transform: translateY(-50%);">
                        <i class="fa fa-bars my-1" style="font-size: 18px;"></i>
                    </button>
                </template>
            </div>
        </nav>

        <!-- Main Content -->
        <div class="px-3 px-md-5 page-main-content" style="min-height: 100vh;">
            <div class="featured-content-bg py-1 py-md-2">

                <div v-if="this.settings.container.title" class="my-0 pt-4 pt-md-4 text-center">
                    <h3 class="m-0">{{this.settings.container.title}}</h3>
                </div>

                <div class="page-product-selection my-3 my-md-4 pt-0 pt-md-0">

<!--                    ProductSelection component-->
<!--                    first component to be shown. user has to select a product to continue.-->
<!--                    once this product is selected we determine if phone confirmation is required and show corresponding component.-->
<!--                    if user clicks on  "Back to product selection" button, we have to set isProductSelected to false so this component is shown again.-->
                    <div v-if="this.showProductSelection">
                        <div class="row">
                            <div :class="this.elementsWidthClass">
                                <ProductSelection @selectedProduct="this.selectProduct" :isPhoneConfirmed="this.settings.isPhoneConfirmed" :hasFailedPhoneConfirmation="this.settings.hasFailedPhoneConfirmation"/>
                            </div>
                        </div>
                    </div>

                    <div v-if="this.settings.container.showOtherOffers">
                        <div class="row">
                            <div class="text-center" :class="elementsWidthClass">
                                <HardcodedOffers />
                                <div v-if="this.showBackToProductsButton">
<!--                                    <div class="my-0 text-end" :class="elementsWidthClass">-->
                                    <div class="my-0 px-3 text-end">
                                        <button type="button" @click.prevent="this.$emit('menuOptionSelected', 'product_selection')" class="btn btn-primary w-100 text-uppercase fw-bold">Back to Product Selection</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="this.showReviewData">
                        <div :class="this.elementsWidthClass">
                            <div class="card shadow my-2 bg-body rounded h-auto py-4 px-3 py-md-4 px-md-5">
                                <ReviewData :uid="this.$parent.uid" :selectedProduct="this.settings.selectedProduct"/>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

import ProductSelection from './ProductSelection.vue';
import PhoneConfirmation from "./PhoneConfirmation.vue";
import ReviewData from "./ReviewData.vue";
import HardcodedOffers from "./HardcodedOffers.vue";

export default {
    name: 'Container',
    emits: ['toggleSidebar', 'menuOptionSelected'],
    components: {
        ProductSelection,
        PhoneConfirmation,
        ReviewData,
        HardcodedOffers,
    },
    props: {
        settings: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            phoneConfirmationIsModal: true,
            phoneConfirmationFailedAttempts: 0,
            containerTitle: null,
            productsThatNeedReviewData: ['personal_loan', 'car_loan']
        }
    },
    mounted() {
        // lets check if we have any data in local storage
        let localStorageData = JSON.parse(localStorage.getItem(`refresh-results-${this.$parent.uid}`));
        console.log('localStorageData');
        console.log(localStorageData);
        if( localStorageData && localStorageData.phoneNumberConfirmed ) {
            console.log('localStorageData success');
            this.handlePhoneConfirmation();
            this.settings.container.title = null;
        }

    },
    methods: {
        toggleSidebar() {
            console.log('Toggling sidebar');
            this.settings.sidebar.isActive = !this.settings.sidebar.isActive;
        },
        selectProduct(product) {
            console.log('Product selected: ' + product);
            this.settings.selectedProduct = product;
            this.settings.container.showOtherOffers = false;

            switch (product) {
                case 'other_offers':
                    this.settings.container.showOtherOffers = true;
                    break;
                case '1_click_application':
                    alert('submitting 1-click application');
                    break;
                case 'personal_loan':
                case 'car_loan':
                    break;
                default:
                    break;
            }
        },
        handlePhoneConfirmation() {
            this.settings.hasFailedPhoneConfirmation = false;
            this.settings.isPhoneConfirmed = true;
            this.settings.sidebar.isActive = true;
            this.settings.container.title = "Thanks for confirming your phone number!";
            this.phoneConfirmationFailedAttempts = 0;
        },
        handlePhoneConfirmationFailed(failedAttemptsIncrease = 1) {
            this.settings.isPhoneConfirmed = false;
            this.settings.sidebar.isActive = false;
            this.phoneConfirmationFailedAttempts+=failedAttemptsIncrease;
            this.settings.hasFailedPhoneConfirmation = this.phoneConfirmationFailedAttempts >= this.settings.phoneConfirmationMaxFailedAttempts;
        }
    },
    computed: {
        showPhoneConfirmation() {
            const productsThatRequirePhoneConfirmation = ['personal_loan', 'car_loan'];
            return this.isProductSelected && !this.settings.isPhoneConfirmed && productsThatRequirePhoneConfirmation.includes(this.settings.selectedProduct);
        },
        canConfirmPhone() {
            return this.isProductSelected && !this.settings.isPhoneConfirmed && !this.settings.hasFailedPhoneConfirmation;
        },
        showProductSelection() {
            return !this.isProductSelected;
        },
        isProductSelected() {
            return !!this.settings.selectedProduct;
        },
        showReviewData() {
            return this.isProductSelected && this.settings.isPhoneConfirmed && this.productsThatNeedReviewData.includes(this.settings.selectedProduct);
        },
        elementsWidthClass() {
            if(this.settings.isMobile) {
                return 'col-12';
            }
            else {
                return this.settings.isPhoneConfirmed ? 'col-lg-10 offset-lg-1 col-xl-6 offset-xl-3' : 'col-lg-8 offset-lg-2 col-xl-6 offset-xl-3';
            }
        },
        showBackToProductsButton() {
            return this.settings.selectedProduct == 'other_offers';
        }
    }

};
</script>

<style scoped>
.modal {
display: block; /* Makes it visible when active */
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
z-index: 9999;
}

.modal-dialog {
position: relative;
top: 50%;
transform: translateY(-50%);
}
</style>
